import request from '@/utils/request';

/**
 * 邀请码服务 - 处理邀请码相关API请求
 */
class InvitationService {
  /**
   * 检查用户是否已有邀请码
   * @returns {Promise} 邀请码信息响应
   */
  checkInviteCode() {
    return request.get('/api/invitation/check');
  }

  /**
   * 生成邀请码
   * @returns {Promise} 生成邀请码响应
   */
  generateInviteCode() {
    return request.get('/api/invitation/generate');
  }

  /**
   * 使用邀请码
   * @param {Object} data - 邀请码数据
   * @returns {Promise} 使用邀请码响应
   */
  useInviteCode(data) {
    return request.post('/api/invitation/use', data);
  }

  /**
   * 获取邀请记录
   * @returns {Promise} 邀请记录响应
   */
  getInvitationRecords() {
    return request.get('/api/invitation/records');
  }
}

export default new InvitationService(); 